import { SurveyLevelDangerousChange } from "@/features/survey_sync/types/syncCheckResult";
import { SurveyTemplateWithQuestions, SurveyToCheckWithQuestionsAndResponses } from "..";

export function checkForSurveyPropertyChanges(
  survey: SurveyToCheckWithQuestionsAndResponses,
  surveyTemplate: SurveyTemplateWithQuestions
): SurveyLevelDangerousChange[] {
  const changes: SurveyLevelDangerousChange[] = [];

  // const crmSystemChange = checkForCrmSystemChange(survey, surveyTemplate);
  // if (crmSystemChange) {
  //   changes.push(crmSystemChange);
  // }

  const nameChange = checkForNameChange(survey, surveyTemplate);
  if (nameChange) {
    changes.push(nameChange);
  }

  const descriptionChange = checkForDescriptionChange(survey, surveyTemplate);
  if (descriptionChange) {
    changes.push(descriptionChange);
  }

  return changes;
}

// function checkForCrmSystemChange(
//   survey: SurveyToCheckWithQuestionsAndResponses,
//   surveyTemplate: SurveyTemplateWithQuestions
// ): SurveyLevelDangerousChange | false {
//   if (survey.crm_system !== surveyTemplate.crm_system) {
//     const context: SurveyCrmSystemChangedContext = {
//       type: "SURVEY_CRM_SYSTEM_CHANGED",
//       oldCrmSystem: survey.crm_system || '',
//       newCrmSystem: surveyTemplate.crm_system || '',
//     };

//     return {
//       type: "SURVEY_CRM_SYSTEM_CHANGED",
//       context,
//     };
//   }

//   return false;
// }

function checkForNameChange(
  survey: SurveyToCheckWithQuestionsAndResponses,
  surveyTemplate: SurveyTemplateWithQuestions
): SurveyLevelDangerousChange | false {
  if (survey.name !== surveyTemplate.name) {
    return {
      type: "SURVEY_NAME_CHANGED",
      context: {
        instanceName: survey.name || '',
        templateName: surveyTemplate.name || '',
      },
    };
  }

  return false;
}

function checkForDescriptionChange(
  survey: SurveyToCheckWithQuestionsAndResponses,
  surveyTemplate: SurveyTemplateWithQuestions
): SurveyLevelDangerousChange | false {
  if (survey.description !== surveyTemplate.description) {
    return {
      type: "SURVEY_DESCRIPTION_CHANGED",
      context: {
        instanceDescription: survey.description,
        templateDescription: surveyTemplate.description,
      },
    };
  }

  return false;
}